import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import {
  getSummerSchoolResearchById,
  getSummerSchoolResearch,
  removeSummerSchoolResearch,
  updateSummerSchoolResearchStatus,
} from "../repositories/summerSchoolResearchRepository";

export const summerSchoolResearchService = {
  getSummerSchoolResearch: async ({ currentPage, pageSize }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    return await getSummerSchoolResearch({
      page: Number(pageNumber) - 1,
      size: itemsPerPage,
    });
  },

  getSummerSchoolResearchById: async (id) =>
    await getSummerSchoolResearchById(id),

  updateSummerSchoolResearchStatus: async (status, body) =>
    await updateSummerSchoolResearchStatus(status, body),

  removeSummerSchoolResearch: async (id) =>
    await removeSummerSchoolResearch(id),
};
